import { useCallback, useState } from "react";
import RoleTableComponent from "./role-table.component";
import TableSort from "../../../../../shared/helpers/table-sort";
import capitalizeFirst from "../../../../../shared/helpers/upper-case";
import { useQuery } from "@tanstack/react-query";
import { getRoles } from "../../../../../core/api/services/role.service";

const RoleComponent = () => {
  const [PageNumber, setPageNum] = useState<number>(1);
  const pageSize = 10;
  const [SortBy, setSortBy] = useState<any>(capitalizeFirst("name"));
  const [SortDirection, setSortDirection] = useState<any>("desc");
  const [roleSearchValue, setRoleSearchValue] = useState("");

  const [columns, setColumns] = useState([
    {
      title: "Role",
      label: "name",
      isSorted: true,
    },
    {
      title: "Description",
      label: "roleDetail",
    },
  ]);

  const { data: roles, isLoading: isLoading } = useQuery({
    queryKey: ["getRoles", PageNumber, SortBy, SortDirection, roleSearchValue],
    queryFn: ({ signal }) =>
      getRoles(
        PageNumber,
        pageSize,
        SortBy,
        SortDirection,
        roleSearchValue,
        signal
      ),
  });

  const handleChangePage = useCallback((page: number): void => {
    setPageNum(page);
  }, []);

  const handleChangeSort = useCallback(
    async (sortBy: string, sortDirection: any) => {
      if (!sortBy || !sortDirection) return;
      setSortBy(sortBy);
      setSortDirection(sortDirection);

      const copyColumns: any = await TableSort(columns, sortBy);
      setColumns(copyColumns);
    },
    []
  );

  const handleSearch = useCallback((searchVal: string): void => {
    setPageNum(1);
    setRoleSearchValue(searchVal);
  }, []);

  return (
    <div>
      <RoleTableComponent
        columns={columns}
        data={roles?.data}
        totalNumberOfRecords={roles?.numberOfRecords}
        pageSize={pageSize}
        current={PageNumber}
        onChangePage={handleChangePage}
        onChangeSort={handleChangeSort}
        isLoading={isLoading}
        onSearch={handleSearch}
      />
    </div>
  );
};

export default RoleComponent;
